import styled from "styled-components/macro";
import TextButton from "../TextButton";

export const SortableItemContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  /* border: 1.5px solid var(--grey-3); */
  border-radius: 8px;
  padding: 6px 10px;
  box-shadow: var(--reorderable-list-drop-shadow);
  background-color: var(--menu-color-fullscreen);

  .grabber {
    cursor: grab;
    fill: var(--grey-0);

    &.disabled {
      cursor: not-allowed;
    }
  }

  .item-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    flex: 1;

    span {
      min-height: 32px;
      display: inline-flex;
      align-items: center;
    }

    .built-in {
      color: var(--grey-2);
      font-size: 10px;
    }

    .actions {
      display: none;
    }

    &:hover {
      .actions {
        display: block;
      }
    }
  }
`;

export const RemoveButton = styled(TextButton)`
  .text-button-inner {
    color: var(--danger-color);
  }

  &:hover {
    & > div {
      background-color: var(--danger-color-hover);
    }
  }

  &:active {
    & > div {
      background-color: var(--danger-color-active);
    }
  }
`;

export const CustomizeModalContent = styled.div`
  width: 100%;
  color: var(--grey-0);
  .sortable-list {
    box-sizing: border-box;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    padding: 12px 8px 10px 8px;

    li {
      width: 100%;
    }

    .section-divider {
      display: flex;
      align-items: center;
      gap: 8px;
      color: var(--grey-2);
      font-size: 12px;
      margin: 4px 0 4px 0;

      &::before,
      &::after {
        content: "";
        flex: 1;
        height: 1px;
        background: var(--menu-color-hover);
      }

      span {
        white-space: nowrap;
      }
    }
  }

  .modal-content {
    .error {
      padding: 8px 8px;
    }
  }
`;
